export enum SubordinateGoalStatus {
    Pending = 0,
    WaitingValidation = 1,
    WaitingChanges = 2,
    Validated = 3
}
